import { FunctionComponent } from 'react'

import dynamic from 'next/dynamic'
import styled, { css } from 'styled-components'

import useHasInvertedColors from '@hooks/useHasInvertedColors'
import { bodyStyle } from '@widgets/Body/bodyStyle'

const HTMLView = dynamic(() => import('@components/HTMLView'))

const allowedHtmlTags = [
  'h2',
  'h3',
  'br',
  'p',
  'ul',
  'ol',
  'li',
  'em',
  'strong',
  'a',
  'sub',
  'sup',
]

const StyledTextWrapper = styled.div<{ hasInvertedColors: boolean }>`
  ${({
    theme: {
      colors: { textDefault, textBrand, staticWhite },
      spacing: { spacing8, spacing16 },
    },
    hasInvertedColors,
  }) => css`
    &&& {
      ${bodyStyle};
      color: ${hasInvertedColors ? staticWhite : textDefault};
      display: unset;

      &:empty {
        display: none;
      }

      p {
        margin: 0 0 ${spacing16} 0;
        overflow: initial;
      }

      p:last-child,
      ul:last-child {
        margin-bottom: 0;
      }

      ul {
        margin: ${spacing8} 0;
      }

      ol {
        margin: ${spacing8} 0;
        padding-left: 1.7em;
      }

      strong {
        font-weight: bold;
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin: ${spacing16} 0 ${spacing8} 0;
      }

      em {
        font-style: italic;
      }

      a,
      a:active,
      a:visited,
      a:active {
        color: ${hasInvertedColors ? staticWhite : textDefault};
        font-weight: normal;
        text-decoration: underline;
      }

      a:hover {
        color: ${textBrand};
        text-decoration: underline;
      }
    }
  `}
`

const TextboxEntityTextWrapper: FunctionComponent<{ children: string }> = ({
  children,
}) => {
  const hasInvertedColors = useHasInvertedColors()

  return (
    <StyledTextWrapper hasInvertedColors={hasInvertedColors}>
      <HTMLView
        content={children}
        allowedHtmlTags={allowedHtmlTags}
        inTextBox={true}
      />
    </StyledTextWrapper>
  )
}

export default TextboxEntityTextWrapper
